import React, { useContext, createRef, useState } from "react";
import * as style from "./style.mod.scss";
import PDPReviews from "components/pdp-reviews";
import RichText from "components/rich-text";
import ProductPrice from "./pdp-prices";
import ProductContext from "services/product-context";

const ProductVariations = () => {
  const { pan, currentV } = useContext(ProductContext);
  const layoutRef = createRef();
  const [totalPrice] = useState(parseFloat(currentV.store.price));
  const title = pan?.product?.store?.productTitle;
  const content = pan?.content;
  const mergedReviewVariants = pan.currentVariant;

  return (
    <div className={style.singleProduct} ref={layoutRef}>
      <div className={style.productDataView}>
        <h1 className={style.productTitle} dangerouslySetInnerHTML={{ __html: title }} />
        <PDPReviews variants={mergedReviewVariants} />
        {content?.benefits && (
          <div className={style.benefits} >
            <RichText blocks={content?.benefits} />
          </div>
        )}
        <ProductPrice
          totalPrice={totalPrice}
          discountBadge={pan?.settings?.PDPSettings?.showYouSave}
          currentVariant={currentV}
        />
      </div>
    </div>
  );
};

export default ProductVariations;
